import React, { Component } from "react";
import axios from "axios";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CustomLoader from "./CustomLoader";
import { CircularProgress } from "@mui/material";
import { withRouter } from "../helpers/withRouter";

class ModifyAppraiser extends Component {
  state = {
    pageReady: false,
    appData: [],
    submitting: false,
    changes: false,
    errors: {},
  };

  componentDidMount() {
    this.getAppraiserData();
  }

  async getAppraiserData() {
    const response = axios.get("../getappraiserdata", {
      params: { pAppraiser: this.props.router.params.id },
    });

    // the response.data will contain the values returned
    var resultData = (await response).data;
    if (resultData) {
      this.setState({
        pageReady: true,
        userName: resultData.userName,
        fullName: resultData.name,
        company: resultData.company,
        email: resultData.email,
        phone: resultData.phone,
      });
    }
  }

  captureInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errors: { ...this.state.errors, [`${e.target.name}Error`]: null },
      changes: true,
    });
  };

  async EditAppraiser() {
    const errors = {};
    const requiredFields = [
      "fullName",
      "userName",
      "company",
      "email",
      "phone",
    ];
    const emailValidate =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // required fields validation
    requiredFields.forEach((field) => {
      if (!this.state[field] || this.state[field].length < 1) {
        errors[`${field}Error`] = `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } Not Specified`;
      }
    });
    if (
      this.state.email &&
      !emailValidate.test(String(this.state.email).toLowerCase())
    ) {
      errors.emailError = "Invalid Email Address";
    }
    if (this.state.phone && this.state.phone.length < 10) {
      errors.phoneError = "Phone must be at least 10 digits long";
    }
    if (this.state.phone && !/^\d+$/.test(this.state.phone)) {
      errors.phoneError = "Phone must be digits only";
    }

    // if any errors render them in page
    if (Object.values(errors).length > 0) {
      this.setState({ errors, submitting: false });
    } else {
      this.setState({ errors, submitting: true });
      var response = axios.get("../editappraiser", {
        params: {
          pFullName: this.state.fullName,
          pUserName: this.state.userName,
          pCompany: this.state.company,
          pEmail: this.state.email,
          pPhone: this.state.phone,
        },
      });
      var resultData = (await response).data;
      if (resultData === "Success") {
        this.setState({
          successMsg: "Appraiser Information Updated!",
          errorMsg: "",
          submitting: false,
          changes: false,
        });
        this.getAppraiserData();
      } else {
        this.setState({
          successMsg: "",
          errorMsg: resultData,
          submitting: false,
        });
      }
    }
  }

  render() {
    const { appData, pageReady, errorMsg, successMsg, errors } = this.state;
    if (!appData || !pageReady) {
      return <CustomLoader>Modify Appraiser Information</CustomLoader>;
    }
    return (
      <Container
        sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
      >
        <Typography variant="h5" sx={{ fontWeight: "medium", mb: 2, mt: 4 }}>
          Modify Appraiser Information
        </Typography>
        <Box sx={{ width: 320, p: 2 }} role="presentation">
          <TextField
            value={this.state.userName}
            name="userName"
            label="User Name"
            disabled={true}
            error={errors.userNameError ? true : false}
            helperText={errors.userNameError}
            onChange={this.captureInput}
            size="small"
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            value={this.state.fullName}
            name="fullName"
            label="Full Name"
            error={errors.fullNameError ? true : false}
            helperText={errors.fullNameError}
            onChange={this.captureInput}
            size="small"
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            value={this.state.company}
            name="company"
            label="Company"
            error={errors.companyError ? true : false}
            helperText={errors.companyError}
            onChange={this.captureInput}
            size="small"
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            value={this.state.email}
            name="email"
            label="Email"
            error={errors.emailError ? true : false}
            helperText={errors.emailError}
            onChange={this.captureInput}
            size="small"
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            value={this.state.phone}
            name="phone"
            label="Phone"
            error={errors.phoneError ? true : false}
            helperText={errors.phoneError}
            onChange={this.captureInput}
            size="small"
            fullWidth
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            onClick={this.EditAppraiser.bind(this)}
            color="primary"
            disabled={this.state.submitting || !this.state.changes}
            size="small"
            fullWidth
            sx={{ mb: 2 }}
          >
            Update Information
          </Button>

          {this.state.submitting && (
            <Stack justifyContent="center" alignItems="center" p={4}>
              <CircularProgress />
            </Stack>
          )}
        </Box>

        {errorMsg && (
          <Alert
            severity="error"
            onClose={() => this.setState({ errorMsg: "" })}
          >
            {errorMsg}
          </Alert>
        )}
        {successMsg && (
          <Alert
            severity="info"
            onClose={() => this.setState({ successMsg: "" })}
          >
            {successMsg}
          </Alert>
        )}
      </Container>
    );
  }
}
export default withRouter(ModifyAppraiser);
